import { Component } from "@angular/core";

@Component({
    selector: "elpc-root",
    templateUrl: "./app.template.html",
    styleUrls: ["./app.style.scss"]
})
export class AppComponent {}
